import biciboxIcon from '../assets/images/parking/bicibox.svg';
import parkingIcon from '../assets/images/parking/parking-white.svg';
import shelteredIcon from '../assets/images/parking/sheltered-white.svg';
import supervisedIcon from '../assets/images/parking/supervised-white.svg';
import veligoIcon from '../assets/images/parking/veligo.svg';
import veloceoIcon from '../assets/images/parking/veloceo.svg';
import velocityIcon from '../assets/images/parking/velocity.svg';
export const parkingPointColors = {
  other: '#528BE8',
  private: '#6236BD',
  secure: '#03825C'
};
export class Parking {
  constructor(id, code, location, capacity, rackType, accessType, free, sheltered, station, supervised, locked, subscription, network, website, startDate = null, osmId = null, osmGeom = null, operator = null, networkName = null) {
    this.id = id;
    this.code = code;
    this.location = location;
    this.capacity = capacity;
    this.rackType = rackType;
    this.accessType = accessType;
    this.free = free;
    this.sheltered = sheltered;
    this.station = station;
    this.supervised = supervised;
    this.locked = locked;
    this.subscription = subscription;
    this.network = network;
    this.website = website;
    this.startDate = startDate;
    this.osmId = osmId;
    this.osmGeom = osmGeom;
    this.operator = operator;
    this.networkName = networkName;
    this.type = this.locked ? 'locked' : this.supervised ? 'supervised' : this.sheltered ? 'sheltered' : !this.free ? 'toll' : 'simple';
  }
}
export const parkingNetworks = {
  bicibox: {
    title: 'Bicibox',
    color: '#337ab7',
    icon: biciboxIcon
  },
  veligo: {
    title: 'Véligo',
    color: '#57585A',
    icon: veligoIcon
  },
  velocity: {
    title: 'Velocity',
    color: '#00297e',
    icon: velocityIcon
  },
  veloceo: {
    title: 'Vélocéo',
    color: '#02495e',
    icon: veloceoIcon
  }
};
export const parkingTypes = {
  sheltered: {
    icon: shelteredIcon,
    labelKey: 'commons.parking.sheltered'
  },
  simple: {
    icon: parkingIcon,
    labelKey: 'commons.parking.free'
  },
  supervised: {
    icon: supervisedIcon,
    labelKey: 'commons.parking.supervised'
  },
  locked: {
    icon: supervisedIcon,
    labelKey: 'commons.parking.locked'
  },
  // TODO : change me
  toll: {
    icon: parkingIcon,
    labelKey: 'commons.parking.toll'
  }
};
export function isParkingSecure({
  locked,
  rackType,
  supervised
}) {
  return locked || supervised || ['building', 'lockers', 'shed'].includes(rackType);
}
export function isParkingPrivate({
  accessType
}) {
  return accessType === 'private';
}
export function isParkingCovered({
  sheltered
}) {
  return sheltered;
}
export function isParkingOperated({
  operator
}) {
  return Boolean(operator);
}
export function getParkingPointColor(parking) {
  if (isParkingSecure(parking)) return parkingPointColors.secure;
  return parkingPointColors.other;
}
export function getParkingNetworkLabel({
  network,
  networkName
}) {
  if (network) return parkingNetworks[network].title;
  return networkName;
}